import {
  ALL_FEATURES as SHARED_ALL_FEATURES,
  PASSES as SHARED_PASSES,
  PASS_FEATURES as SHARED_PASS_FEATURES,
  type PassInfo,
  type PassType,
} from "@workspace/gamja-platform/types/pass";

export * from "@workspace/gamja-platform/types/pass";

// JCG 전용 기능 선언. 다른 시험 앱의 이용권 구성에는 영향을 주지 않는다.
export const PASS_FEATURES = {
  ...SHARED_PASS_FEATURES,
  problemNavigation: "문제 목록·번호 이동",
} as const;

// 10/25 배포 상품 가격. 과거 승인 거래 재검증만 이전 가격을 사용한다.
export const MEMBERSHIP_PRICE_CHANGE_AT = "2026-10-25T00:00:00+09:00";

const UPDATED_PASS_PRICES = {
  starter: { price: 4900, youtubePrice: 3900 },
  premium: { price: 16900, youtubePrice: 14900 },
  intelligence: { price: 29900, youtubePrice: 25900 },
} as const;

export function getPassPrices(type: PassType, historicalDate?: string | number | Date) {
  if ((historicalDate === undefined || new Date(historicalDate).getTime() >= Date.parse(MEMBERSHIP_PRICE_CHANGE_AT)) && type in UPDATED_PASS_PRICES) {
    return UPDATED_PASS_PRICES[type as keyof typeof UPDATED_PASS_PRICES];
  }
  return { price: SHARED_PASSES[type].price, youtubePrice: SHARED_PASSES[type].youtubePrice };
}

const withProblemNavigation = (pass: PassInfo): PassInfo => ({
  ...pass,
  ...getPassPrices(pass.type),
  features: [...pass.features, PASS_FEATURES.problemNavigation],
});

export const PASSES = {
  ...SHARED_PASSES,
  starter: withProblemNavigation(SHARED_PASSES.starter),
  premium: withProblemNavigation(SHARED_PASSES.premium),
  complete: withProblemNavigation(SHARED_PASSES.complete),
  intelligence: withProblemNavigation(SHARED_PASSES.intelligence),
};

export const ALL_FEATURES = SHARED_ALL_FEATURES.flatMap((feature) =>
  feature.id === "sidePanel"
    ? [feature, { id: "problemNavigation", name: PASS_FEATURES.problemNavigation }]
    : [feature],
);
